import { RequestKind, boolean, string } from '@sb/library/base';
import { AutoInvoiceUpdateItem, DisplayItemCollection, FamilyDisplayItem, FamilyInputItem, FamilyPayableDisplayItem, FamilySearchOptions, FamilyUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace FamilyRoutes {
    export const Add = ApiRoute.Define({
        URL: 'families',
        Kind: RequestKind.Post,
        BodyType: FamilyInputItem,
        ResultType: string
    });

    export const Get = ApiRoute.Define({
        URL: (familyID: string) => `families/${familyID}`,
        Kind: RequestKind.Get,
        ResultType: FamilyDisplayItem,
        RequestedFieldsType: FamilyDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: 'families',
        Kind: RequestKind.Get,
        OrderByType: FamilyDisplayItem,
        RequestedFieldsType: FamilyDisplayItem,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<FamilyDisplayItem>
    });

    export const GetPaymentDetails = ApiRoute.Define({
        URL: (familyID: string) => `families/${familyID}/paymentdetails`,
        Kind: RequestKind.Get,
        ResultType: FamilyPayableDisplayItem
    });

    export const Search = ApiRoute.Define({
        URL: 'search/families',
        Kind: RequestKind.Post,
        BodyType: FamilySearchOptions,
        OrderByType: FamilyDisplayItem,
        RequestedFieldsType: FamilyDisplayItem,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<FamilyDisplayItem>
    });

    export const Delete = ApiRoute.Define({
        URL: (familyID: string) => `families/${familyID}`,
        Kind: RequestKind.Delete,
        BodyType: FamilyUpdateItem,
        ResultType: boolean
    });

    export const Update = ApiRoute.Define({
        URL: (familyID: string) => `families/${familyID}`,
        Kind: RequestKind.Put,
        BodyType: FamilyUpdateItem,
        ResultType: boolean
    });

    export const UpdateAutoInvoice = ApiRoute.Define({
        URL: (familyID: string) => `families/${familyID}/autoinvoice/`,
        Kind: RequestKind.Put,
        BodyType: AutoInvoiceUpdateItem,
        ResultType: boolean
    });
}
